<template>
  <div
    :class="`card card-custom card-stretch card-stretch-half gutter-b`"
    v-if="pwnedStatus !== false && isProfileLoaded"
  >
    <div class="card-body d-flex">
      <div class="d-flex align-items-center p-2">
        <div class="mr-10">
          <span :class="`svg-icon svg-icon-${pwnedStatus} svg-icon-6x`">
            <simple-svg
              v-if="pwnedStatus === 'warning'"
              :src="require('@/assets/images/icons/warning-circle.svg')"
            />
            <simple-svg
              v-else-if="pwnedStatus === 'success'"
              :src="require('@/assets/images/icons/done-circle.svg')"
            />
            <simple-svg
              v-else-if="pwnedStatus === 'danger'"
              :src="require('@/assets/images/icons/warning-triangle.svg')"
            />
            <simple-svg
              v-else
              :src="require('@/assets/images/icons/mail-locked.svg')"
            />
          </span>
        </div>
        <div class="d-flex flex-column">
          <p class="text-dark mb-5 text-left font-size-h3 font-weight-bolder">
            {{ $t(`messages.dashboard.pwned.${pwnedStatus}.title`) }}
          </p>
          <div class="text-dark-75 text-left pb-8">
            {{
              $t(
                `messages.dashboard.pwned.${pwnedStatus}.content.description`,
                {
                  date: date
                }
              )
            }}
          </div>
          <b-button
            class="font-weight-bolder text-uppercase py-4 mt-2"
            tag="a"
            :variant="pwnedStatus"
            :to="{ name: 'Breaches' }"
            pill
            v-if="pwnedStatus !== 'success'"
          >
            {{ $t(`messages.dashboard.pwned.${pwnedStatus}.content.ending`) }}
          </b-button>
          <b-button
            class="font-weight-bolder text-uppercase py-4 mt-2"
            tag="a"
            :variant="pwnedStatus"
            pill
            @click="activate({ bot: 'breaches', forceStatus: 'UNAVAILABLE' })"
            v-else
          >
            {{ $t(`messages.dashboard.pwned.${pwnedStatus}.content.ending`) }}
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import { SimpleSVG } from "vue-simple-svg";

export default {
  name: "Pwned",
  props: {
    pwned: {
      required: true
    }
  },
  components: {
    "simple-svg": SimpleSVG
  },
  computed: {
    ...mapGetters("Profile", ["pwnedStatus", "isProfileLoaded"]),
    date() {
      return this.pwned.answer
        ? moment(this.pwned.answer.maxdate).format("LL")
        : "";
    }
  },
  methods: {
    ...mapActions("Chatbot", ["activate"])
  }
};
</script>
